export const PANEL_CLOSE_BUTTON_TEST_ID = 'panel-close-button';
export const PANEL_CTA_BUTTON_TEST_ID = 'panel-cta-button';
